// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__Ptoxq","noInteraction":"EventWrapper_noInteraction__3ZN5f","pointerPassthrough":"EventWrapper_pointerPassthrough__3hc35"};